export default __webpack_public_path__ + "static/media/flujoEfectivoIcon.6db83982.svg";